/*  React  */
import React, { createContext, useContext, useMemo } from 'react';

type SaasAppUsersPageTableContextValue = {
    reloadApplication: () => void;
};
const defaultFn = () => {};

const defaultContext: SaasAppUsersPageTableContextValue = {
    reloadApplication: defaultFn
};

export const SaasAppUsersPageTableContext = createContext(defaultContext);

export const SaasAppUsersPageTableContextProvider = ({
    children,
    reloadApplication
}: {
    children: React.ReactNode;
    reloadApplication: () => void;
}) => {
    const providerValues = useMemo(
        () => ({
            reloadApplication
        }),
        [reloadApplication]
    );

    return (
        <SaasAppUsersPageTableContext.Provider value={providerValues}>
            {children}
        </SaasAppUsersPageTableContext.Provider>
    );
};

export const useSaasAppUsersPageContext = () => {
    const context = useContext(SaasAppUsersPageTableContext);

    if (context === undefined) {
        throw new Error(
            '`useSaasAppUsersPageContext` must be used within `SaasAppUsersPageTableContextProvider`'
        );
    }

    return context;
};
